<template>
<div>
    <div class="row mb-2"  v-for="(inp,idx) in inputs" :key="idx">
      <div class="col-10 col-lg-6">
        <div class="holder">
          <input
          :id="id"
          :type="type"
          v-model="inputs[idx]"
          class="form-control"
          @input="emmitEvent"
          @keydown="emitKeydown"
          @change="emitChange"
          :aria-labelledby="id+'_label'"
          :maxlength="maxlength"
          :autocomplete="autocomplete"
          :readonly="readonly"
          :step="(type == 'number'?1:null)"
          :pattern="(type == 'number'?'[0-9]*':null)"
        >
      </div>
    </div>
    <div class="col-2 col-lg-2"><button class="btn btn-danger" @click="del(idx)" v-if="inputs.length > 1"><i class="bi bi-x-circle-fill"></i><span class="sr-only"> {{ $t('usun_wiersz') }}</span></button></div>
  </div>
  <button class="btn btn-success" @click="add()" v-if="!maxinputs || (maxinputs > inputs.length)"><i class="bi bi-plus-circle"></i> {{ $t('dodaj') }}</button>
</div> 
</template>

<script>
export default {
  name: "IcMultipleInput",
  props: {
    id: { type: String },
    value: { type: [String, Number, Array] },
    type: { type: String, default: "text" },
    
    v: { type: Object },
    autocomplete: {type:String},
    readonly: {type:Boolean, default: false},
    maxlength: { type: [String,Number], default: null },
    maxinputs: {type: Number, default: 0},
  },
  data() {
    return {
      data: this.value,
      numOfInputs: 1,
      inputs: this.data?this.data.toString().split("|"):[""]
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        //console.log(this.inputs);
        this.data =  this.inputs.join("|");
      }
    }
  },
  computed: {
    charactersLeft(idx) {
    }
  },
  methods: {
    add(){
      this.inputs.push("");
    },
    del(idx){
        this.inputs.splice(idx, 1);
    },
    emmitEvent(event) {
      
      this.$emit("input", this.inputs.join("|"));
      if (this.v) {
        this.v.$touch();
      }
    },
    emitKeydown(event) {
      this.$emit("keydown", event);
      if (this.v) {
        this.v.$touch();
      }
    },
    emitChange(event) {
      this.$emit("change", event);
      if (this.v) {
        this.v.$touch();
      }
    }
  }
};
</script>

<style>
.holder {
  position: relative;
}
.counter {
  position: absolute;
margin-top: -34px;
right: 10px;
font-size: 70%;
}
</style>
